///all in one
import axios from "@/axios";
export const singUpStates = {
  participant_type: 1,
  company_name: "",
  firstname: "",
  lastname: "",
  firstname_en: "",
  lastname_en: "",
  gender: "",
  dob: "",
  nationality: 36,
  dial_code: "+855",
  national_id_card: "",
  phone: "",
  email: "",
  password: "",
  password_confirmation: "",
  verification_code: ""
};

export const singUpGetters = {
  getSingUp: state => {
    return state.sign_up;
  }
};

export const singUpMutations = {
  changesingup(state, value) {
    state.sign_up = value;
  }
};

export const singUpActions = {
  act_changesingup: ({ commit }, payload) => {
    commit("changesingup", payload);
  },
  act_signup: async ({ commit }, payload) => {
    try {
      let respone = await axios.post("create-account", payload.form);
      commit("changeAuthCode", respone.data);
      console.log("it is respone", respone);
      return respone;
    } catch (err) {
      console.log("it is error respone", err.response);
      console.log("it is error", err.response);
      return err.response;
    }
  }
};
